module.exports = __webpack_public_path__ + "media/registry_800.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/registry_800.jpg
// module id = 36
// module chunks = 0